import { observer } from 'mobx-react';
import RefundLogHeader from 'src/view/screens/RefundLogScreen/screens/RefundLog/containers/RefundLogHeader/RefundLogHeader';
import RefundLogList from 'src/view/screens/RefundLogScreen/screens/RefundLog/containers/RefundLogList/RefundLogList';
import Headers from 'src/view/containers/Headers/Headers';
import HeaderBack from '~/view/containers/Headers/components/HeaderBack/HeaderBack';
import { SCREENS } from '~/constants/screens';
import LogNavigation from '~/view/components/LogNavigation/LogNavigation';

const RefundLog = (): JSX.Element => {
  return (
    <>
      <Headers>
        <HeaderBack title="reports_refund_journal_btn_title" path={SCREENS.REPORTS()} />
      </Headers>
      <LogNavigation />
      <div className="mt-6"></div>
      <RefundLogHeader />
      <RefundLogList />
    </>
  );
};

export default observer(RefundLog);
